import { makeApiError, makeApiSuccess } from 'scenes/common/helpers/apiData';
import { ApiData } from 'scenes/common/types';

import { WireCoverLevels, CoverLevel } from './types';

export const unmarshalCoverLevels = (
  coverLevels: WireCoverLevels
): ApiData<CoverLevel[]> => {
  const coverLevelList = Object.values(coverLevels);
  return coverLevelList.length > 0
    ? makeApiSuccess(
        coverLevelList.map((coverLevel) => ({
          insurerCode: coverLevel.flagname,
          value: coverLevel.code,
          label: coverLevel.value,
        }))
      )
    : makeApiError('Not found');
};
